import { jsx as _jsx } from "react/jsx-runtime";
const text = {
    PENDING: "待呼叫",
    CALLING: "呼叫中",
    ANSWERED: "已接听",
    NO_ANSWER: "无人接听",
    CANCELLED: "已取消"
};
export function StatusBadge({ status }) {
    return _jsx("span", { className: `tag ${status.toLowerCase()}`, children: text[status] });
}
